import { Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useSEO } from "@/lib/useSEO";
import { locations } from "@/data/locations";
import { MapPin, ArrowRight, Video } from "lucide-react";

export default function Locations() {
  useSEO({
    title: "Boxing Lessons in Somerset County & Central NJ — In-Person & Virtual | Better Through Boxing",
    description: "Private in-home boxing lessons across Somerset County and Central New Jersey — Bridgewater, Somerville, Edison, Westfield, Princeton, Hillsborough and every town in between — plus virtual coaching worldwide with Coach Chris.",
    path: "/boxing-lessons",
    keywords: ["boxing lessons near me", "boxing coach somerset county nj", "private boxing lessons central new jersey", "in-home boxing trainer nj"],
  });

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <SiteHeader />
      <section className="max-w-5xl mx-auto px-6 pt-16 pb-10">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#FF331F] font-bold">Service Area</p>
        <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight mt-3">Boxing Lessons Across Somerset County & Central NJ</h1>
        <p className="text-zinc-400 text-base mt-4 max-w-2xl">Coach Chris brings private, in-home boxing training to your door across Somerset County and Central New Jersey — and coaches virtually anywhere in the world. Pick your town below, or train over Zoom from anywhere.</p>
        <Link to="/book" className="inline-flex items-center gap-2 mt-6 bg-[#FF331F] hover:bg-[#FF5242] text-white uppercase tracking-widest font-bold text-xs px-6 py-3" data-testid="locations-book-cta">
          Book a session <ArrowRight className="h-4 w-4" />
        </Link>
      </section>

      <section className="max-w-5xl mx-auto px-6 pb-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {locations.map((l) => (
          <Link key={l.slug} to={`/boxing-lessons/${l.slug}`} data-testid={`location-card-${l.slug}`}
            className="group border border-[#27272A] bg-[#0F0F0F] p-5 hover:border-[#FF331F] transition-colors">
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-[#FF331F]" />
              <span className="font-display uppercase tracking-tight text-lg">{l.city}</span>
            </div>
            <div className="text-xs text-zinc-500 mt-1">{l.county}, NJ</div>
            <div className="text-[11px] uppercase tracking-widest text-zinc-600 mt-3 group-hover:text-[#FF331F]">Boxing lessons →</div>
          </Link>
        ))}
      </section>

      <section className="max-w-5xl mx-auto px-6 pb-20">
        <div className="border border-[#27272A] bg-[#0F0F0F] p-6 flex items-center gap-4">
          <Video className="h-6 w-6 text-[#FF331F] shrink-0" />
          <div>
            <div className="font-display uppercase tracking-tight text-lg">Not in New Jersey?</div>
            <p className="text-sm text-zinc-400">Coach Chris coaches virtually over Zoom — same technique, same attention, anywhere in the U.S. or worldwide. <Link to="/services" className="text-[#FF331F] underline">See virtual coaching →</Link></p>
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
